import React from "react";
import { Typography, Box} from '@mui/material';
import WhatsAppButton from "./WhatsApp";

function PageAppBar2() {
    return (
        <Box style={{backgroundColor: 'transparent', width: '210px'}}>
            <WhatsAppButton />
            <Typography style={{color: "white", fontSize:"13px"}} component="div">
                FALE CONOSCO
                </Typography>
                <Typography mt={1} style={{color: "#9e9e9e", fontStyle: "bold"}} variant="subtitle2" color="text.secondary">
                    (14) 99907-3514
            </Typography>
        </Box>   
    );
};
export default PageAppBar2;